
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "commitHash": "68be71fd14ffd87bd0a0f91dab60d69c8665e88c",
    "version": "10.2.0"
};
/* tslint:enable */
